import { areSameValue } from '../../core/utils'

import findNodeByFilter from './find-node-by-filter'

const findNodeByValue = (tree = [], value) =>
  findNodeByFilter(tree, ({ value: nodeValue }) =>
    areSameValue(nodeValue, value),
  )

export default findNodeByValue
